var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 6.5C8.56375 6.5 9.9375 5.12625 9.9375 3.4375C9.9375 1.74875 8.56375 0.375 6.875 0.375C5.18625 0.375 3.8125 1.74875 3.8125 3.4375C3.8125 5.12625 5.18625 6.5 6.875 6.5ZM6.875 2.125C7.60125 2.125 8.1875 2.71125 8.1875 3.4375C8.1875 4.16375 7.60125 4.75 6.875 4.75C6.14875 4.75 5.5625 4.16375 5.5625 3.4375C5.5625 2.71125 6.14875 2.125 6.875 2.125ZM6.91875 10.875H3.17375C4.04 10.4375 5.53625 10 6.875 10C6.97125 10 7.07625 10.0087 7.1725 10.0087C7.47 9.37 7.98625 8.845 8.6075 8.425C7.96875 8.31125 7.365 8.25 6.875 8.25C4.8275 8.25 0.75 9.27375 0.75 11.3125V12.625H6.875V11.3125C6.875 11.1637 6.8925 11.015 6.91875 10.875ZM13.4375 8.6875C11.8275 8.6875 8.625 9.57125 8.625 11.3125V12.625H18.25V11.3125C18.25 9.57125 15.0475 8.6875 13.4375 8.6875ZM14.4962 7.095C15.1612 6.71875 15.625 6.01 15.625 5.1875C15.625 3.98 14.645 3 13.4375 3C12.23 3 11.25 3.98 11.25 5.1875C11.25 6.01 11.7137 6.71875 12.3787 7.095C12.6938 7.27 13.0525 7.375 13.4375 7.375C13.8225 7.375 14.1812 7.27 14.4962 7.095Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarClients);
export default __webpack_public_path__ + "static/media/navbar-clients.891d1429.svg";
export { ForwardRef as ReactComponent };